export default "__VITE_ASSET__D_Aewh4___"